<div class="cellContainer">
    <div class="rowValue">{{ params.data.Total }}</div>
    <div class="graphContainer">
        <div *ngFor="let state of params.data.ContactCounts; let i = index" class="barContainer"
            [ngStyle]="{'width': (state / params.context.largestStateTotal * 100) + '%', 'display': state <= 0 ? 'none' : 'flex'}">
            <div class="bar" *ngIf="state > 0" [ngStyle]="{'background-color': getStateColor(contactStates[i])}"
                [ngbPopover]="popover" triggers="mouseenter:mouseleave" container="body" containerClass="cxone-popover"
                placement="left">
                <div class="barValue">{{ state }}</div>
            </div>
            <ng-template #popover>
                <div>
                    <div class="inner popoverHeader">{{ params.data.SkillName }}</div>
                    <div class="popoverText">
                        <div class="tooltipColor" [ngStyle]="{'background-color': getStateColor(contactStates[i])}"></div>
                        <span>{{ getLocalizedStateName(contactStates[i]) }}</span>
                        <span class="tooltipCount"> ({{ state }})</span>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>
